function open(hash) {
    if (window.location.hash.split('#').includes(hash)) return;

    window.location.hash += `#${hash}`;
    // FIXME : Ugly fix for Safari
    document.querySelector('html').scrollTo(0, document.querySelector('html').scrollTop - 1);
}

export default open;
